<template>
    <v-dialog v-model="isVisible" persistent max-width="1000" v-if="widget !== null">
        <v-toolbar dark color="primary" >
            <v-icon>edit</v-icon>
            <v-toolbar-title class="white--text" >Edit Widget</v-toolbar-title>
                <v-spacer></v-spacer>
            <v-btn icon @click="close">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs
            v-model="tab"
            centered
            dark
            color="primary">
            <v-tab href="#tab-settings">
                Settings
            </v-tab>
            <v-tab href="#tab-text">
                Text
            </v-tab>
        </v-tabs>
        <v-card >
            <v-card-text>
                <v-tabs-items v-model="tab">
                    <v-tab-item value="tab-settings">
                        <widget-settings-renderer :schema="widget.schema" :data="widget.config.data"></widget-settings-renderer>
                    </v-tab-item>
                    <v-tab-item value="tab-text">
                        <h3>Caption</h3>
                        <v-text-field
                            v-model="widget.config.text.caption.en"
                            label="Caption english"></v-text-field>
                        <v-text-field
                            v-model="widget.config.text.caption.de"
                            label="Caption german"></v-text-field>
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import FormGenerator from 'vuetify-form-generator'
import { mapGetters } from 'vuex'
import widgetSettingsRenderer from './WidgetSettingsRenderer.vue'


export default {
    props: {
        isVisible: {
            type: Boolean,
            required: true
        },
        widget: {
            type: Object,
        },
    },
    components: {
        'v-form-generator': FormGenerator,
        widgetSettingsRenderer
    },
    data() {
        return {
            tab: 'tab-settings'
        }
    },
    computed: {
        ...mapGetters([
			'dashboard'
		])
	},
	methods: {
        close () {
            this.$emit('close')
        },
        modelUpdated(newVal, schema) {
			console.log("model-updated", newVal, schema);
		}
	}
};
</script>
